'use client';
import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, ZoomIn } from 'lucide-react';

const images = [
{ id: 'gal-001', src: "https://images.unsplash.com/photo-1566489385366-a48be9217ce5", alt: 'Construction workers on scaffolding during a home extension build', caption: 'Two-storey extension, Bury St Edmunds (2025)' },
{ id: 'gal-002', src: "https://img.rocket.new/generatedImages/rocket_gen_img_19cba9158-1773093032586.png", alt: 'Finished modern kitchen with island and bi-fold doors', caption: 'Kitchen renovation with bi-fold doors, Newmarket (2025)' },
{ id: 'gal-003', src: "https://img.rocket.new/generatedImages/rocket_gen_img_104bbb00e-1777157898544.png", alt: 'New build detached house with brick exterior and garage', caption: 'New build detached property, Haverhill (2024)' },
{ id: 'gal-004', src: "https://img.rocket.new/generatedImages/rocket_gen_img_1ca4a3d49-1772200826589.png", alt: 'Converted loft bedroom with Velux windows and timber flooring', caption: 'Velux loft conversion, Mildenhall (2024)' },
{ id: 'gal-005', src: "https://images.unsplash.com/photo-1649083047090-fd89bf55b893", alt: 'Modern bathroom with walk-in shower and white tiles', caption: 'Full bathroom refit, Bury St Edmunds (2026)' },
{ id: 'gal-006', src: "https://images.unsplash.com/photo-1720264713961-624eff9c99a8", alt: 'Block paving driveway with edging stones and gate', caption: 'Block paving driveway, Clare (2025)' }];


export default function BusinessGallery() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const openLightbox = (index: number) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);
  const prevImage = () => setLightboxIndex((i) => i !== null ? Math.max(0, i - 1) : null);
  const nextImage = () => setLightboxIndex((i) => i !== null ? Math.min(images.length - 1, i + 1) : null);

  return (
    <div className="card-surface p-6">
      <h2 className="font-bold text-lg text-foreground mb-4">Project Gallery</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {images.map((img, index) =>
        <button
          key={img.id}
          onClick={() => openLightbox(index)}
          className="relative group overflow-hidden rounded aspect-video bg-muted focus:outline-none focus:ring-2 focus:ring-primary"
          aria-label={`View gallery image: ${img.caption}`}>
          
            <img
            src={img.src}
            alt={img.alt}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
          
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
              <ZoomIn size={22} className="text-white opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          </button>
        )}
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null &&
      <div
        className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
        onClick={closeLightbox}>
        
          <button
          className="absolute top-4 right-4 text-white p-2 hover:bg-white/10 rounded transition-colors"
          onClick={closeLightbox}
          aria-label="Close gallery">
          
            <X size={24} />
          </button>
          <button
          className="absolute left-4 top-1/2 -translate-y-1/2 text-white p-2 hover:bg-white/10 rounded transition-colors disabled:opacity-30"
          onClick={(e) => {e.stopPropagation();prevImage();}}
          disabled={lightboxIndex === 0}
          aria-label="Previous image">
          
            <ChevronLeft size={28} />
          </button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
            src={images[lightboxIndex].src}
            alt={images[lightboxIndex].alt}
            className="w-full max-h-[70vh] object-contain rounded" />
          
            <p className="text-white/70 text-sm text-center mt-3">
              {images[lightboxIndex].caption}
            </p>
            <p className="text-white/40 text-xs text-center mt-1">
              {lightboxIndex + 1} / {images.length}
            </p>
          </div>
          <button
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white p-2 hover:bg-white/10 rounded transition-colors disabled:opacity-30"
          onClick={(e) => {e.stopPropagation();nextImage();}}
          disabled={lightboxIndex === images.length - 1}
          aria-label="Next image">
          
            <ChevronRight size={28} />
          </button>
        </div>
      }
    </div>);

}